"use strict";
exports.__esModule = true;
exports.TERRITORIAL_AUTHORITY = void 0;
var TERRITORIAL_AUTHORITY = {
    AUCKLAND: { name: 'Auckland', type: 'City' },
    FRANKLIN: { name: 'Franklin', type: 'District' },
    MANUKAU: { name: 'Manukau', type: 'City' },
    HAMILTON: { name: 'Hamilton', type: 'City' },
    HAURAKI: { name: 'Hauraki', type: 'District' },
    MATAMATA_PIAKO: { name: 'Matamata-Piako', type: 'District' },
    OTOROHANGA: { name: 'Otorohanga', type: 'District' },
    ROTORUA: { name: 'Rotorua', type: 'District' },
    SOUTH_WAIKATO: { name: 'South Waikato', type: 'District' },
    TAUPO: { name: 'Taupo', type: 'District' },
    THAMES_COROMANDEL: { name: 'Thames-Coromandel', type: 'District' },
    RODNEY: { name: 'Rodney', type: 'District' },
    WAITAKERE: { name: 'Waitakere', type: 'City' },
    OPOTIKI: { name: 'Opotiki', type: 'District' },
    WESTERN_BAY_OF_PLENTY: { name: 'Western Bay of Plenty', type: 'District' },
    WHAKATANE: { name: 'Whakatane', type: 'District' },
    ASHBURTON: { name: 'Ashburton', type: 'District' },
    CHRISTCHURCH: { name: 'Christchurch', type: 'City' },
    HURUNUI: { name: 'Hurunui', type: 'District' },
    KAIKOURA: { name: 'Kaikoura', type: 'District' },
    MACKENZIE: { name: 'Mackenzie', type: 'District' },
    SELWYN: { name: 'Selwyn', type: 'District' },
    TIMARU: { name: 'Timaru', type: 'District' },
    WAIMAKARIRI: { name: 'Waimakariri', type: 'District' },
    WAIMATE: { name: 'Waimate', type: 'District' },
    WAITAKI: { name: 'Waitaki', type: 'District' },
    GISBORNE: { name: 'Gisborne', type: 'District' },
    "CENTRAL_HAWKE'S_BAY": { name: "Central Hawke's Bay", type: 'District' },
    HASTINGS: { name: 'Hastings', type: 'District' },
    HASTINGS_CITY: { name: 'Hastings city', type: 'City' },
    NAPIER: { name: 'Napier', type: 'City' },
    WAIROA: { name: 'Wairoa', type: 'District' },
    HOROWHENUA: { name: 'Horowhenua', type: 'District' },
    MANAWATU: { name: 'Manawatu', type: 'District' },
    PALMERSTON_NORTH: { name: 'Palmerston North', type: 'City' },
    RANGITIKEI: { name: 'Rangitikei', type: 'District' },
    RUAPEHU: { name: 'Ruapehu', type: 'District' },
    TARARUA: { name: 'Tararua', type: 'District' },
    WANGANUI: { name: 'Wanganui', type: 'District' },
    MARLBOROUGH: { name: 'Marlborough', type: 'District' },
    NELSON: { name: 'Nelson', type: 'City' },
    TASMAN: { name: 'Tasman', type: 'District' },
    FAR_NORTH: { name: 'Far North', type: 'District' },
    KAIPARA: { name: 'Kaipara', type: 'District' },
    WHANGAREI: { name: 'Whangarei', type: 'District' },
    CENTRAL_OTAGO: { name: 'Central Otago', type: 'District' },
    CLUTHA: { name: 'Clutha', type: 'District' },
    DUNEDIN: { name: 'Dunedin', type: 'City' },
    QUEENSTOWN_LAKES: { name: 'Queenstown-Lakes', type: 'District' },
    GORE: { name: 'Gore', type: 'District' },
    INVERCARGILL: { name: 'Invercargill', type: 'City' },
    SOUTHLAND: { name: 'Southland', type: 'District' },
    NEW_PLYMOUTH: { name: 'New Plymouth', type: 'District' },
    SOUTH_TARANAKI: { name: 'South Taranaki', type: 'District' },
    STRATFORD: { name: 'Stratford', type: 'District' },
    WAIKATO: { name: 'Waikato', type: 'District' },
    WAIPA: { name: 'Waipa', type: 'District' },
    WAITOMO: { name: 'Waitomo', type: 'District' },
    CARTERTON: { name: 'Carterton', type: 'District' },
    HUTT_CITY: { name: 'Hutt city', type: 'City' },
    KAPITI_COAST: { name: 'Kapiti Coast', type: 'District' },
    MASTERTON: { name: 'Masterton', type: 'District' },
    PORIRUA: { name: 'Porirua', type: 'City' },
    SOUTH_WAIRARAPA: { name: 'South Wairarapa', type: 'District' },
    UPPER_HUTT: { name: 'Upper Hutt', type: 'City' },
    WELLINGTON: { name: 'Wellington', type: 'City' },
    BULLER: { name: 'Buller', type: 'District' },
    GREY: { name: 'Grey', type: 'District' },
    WESTLAND: { name: 'Westland', type: 'District' }
};
exports.TERRITORIAL_AUTHORITY = TERRITORIAL_AUTHORITY;
